import styles from "./Projects.module.css"
import Banner from "../../components/Banner"
import Header from "../../components/Header"
import Container from "../../components/Container"
import TitlePages from "../../components/TitlePages"
import Team from "../../components/Team"
import Footer from "../../components/Footer"
import videoPorject from "./video-project.m4v"

import slidesJson from "../Projects/slides.json"
import Slider from "react-slick";
import { useEffect, useState } from "react"



function Projects() {

    const [slidesToShow, setSlidesToShow] = useState(3);
    
      useEffect(() => {
        const mq675 = window.matchMedia("(max-width: 675px)");
        const mq920 = window.matchMedia("(max-width: 920px)");
    
        const update = () => {
          if (mq675.matches) setSlidesToShow(1);
          else if (mq920.matches) setSlidesToShow(2);
          else setSlidesToShow(3);
        };
    
        update(); // inicializa correto na primeira renderização
    
        mq675.addEventListener("change", update);
        mq920.addEventListener("change", update);
    
        mq675.addListener?.(update);
        mq920.addListener?.(update);
    
        return () => {
          mq675.removeEventListener?.("change", update);
          mq920.removeEventListener?.("change", update);
    
          mq675.removeListener?.(update);
          mq920.removeListener?.(update);
        };
      }, []);
    
        const settings = {
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow,
            centerMode: false,
            slidesToScroll: 1
        };

    return(
        <>
            <Header />
            <Banner 
                videoSrc={videoPorject}
                title="Ready to <span>start</span> <br> your project?"
                subtitle="We design and develop games, focusing on engaging gameplay <br> and enhanced with Web3 and blockchain technologies."
                            
            />
            <Container>
                <TitlePages 
                    title="But, why would you <br> want to work <span> with us</span>?"
                    subTitle="Discover how we approach game development <br> and how technologies like Web3 and blockchain <br> can enhance selected projects."
                />

            <div className={styles.project}>
                <Slider {...settings}>
                
                    {slidesJson.map((item) => (
                            <a
                                key={item.id}
                                href={item.url}
                                className={styles.card}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <div className={styles.imgCard}>
                                    <img src={item.img}></img>
                                </div>

                                <h2>{item.title}</h2>
                                <p>{item.subtitle}</p>
                            </a>
                    ))}

                </Slider>
            </div>

                
            </Container>
            <Team />
            <Footer />
        </>
    )
}

export default Projects
